import { useEffect } from 'react';
import {Ya, Environment, QueryParams, Options} from './types';

declare const Ya: Ya;

const FEEDBACK_LIB_TEAM_LINK = 'https://surveys.yandex-team.ru/fb/widget.js';
const FEEDBACK_LIB_LINK = 'https://surveys.yandex.ru/fb/widget.js';
const FEEDBACK_LIB_STAGING_LINK = 'https://pythia-staging.common.yandex.ru/fb/widget.js';

const getFeedbackLibUrl = (environment: Environment) => {
  const isYandexTeamDomain = window.location.host.includes('.yandex-team.ru');

  switch(environment) {
    case 'development':
      return FEEDBACK_LIB_STAGING_LINK;
    case 'production':
      return isYandexTeamDomain ? FEEDBACK_LIB_TEAM_LINK : FEEDBACK_LIB_LINK;
    default:
      return FEEDBACK_LIB_LINK;
  }
}

export function useFeedback(feedbackOwnerId: string, query: QueryParams, options?: Options):void {
  const {
    baseUrl,
    theme,
    forceTheme,
    hideHeader,
    environment = 'production',
    root = document.body,
    uid,
    lang,
    testIds,
    customParams,
    afterInitCb,
  } = options ?? {};

  useEffect(() => {
    const script = document.createElement('script');
    let cleanup;

    script.src = getFeedbackLibUrl(environment);
    script.async = true;
    script.onload = () => {
      cleanup = Ya.Feedback.App.embed(root);
      Ya.Feedback.App.init(feedbackOwnerId, { baseUrl, theme, forceTheme, hideHeader, uid, lang, testIds, customParams });
      afterInitCb?.();
      Ya.Feedback.App.fetch().then(() => {
        Ya.Feedback.App.setDefaultQueryParams(query);
      });
    };

    document.body.appendChild(script);

    return () => {
      cleanup?.();
      document.body.removeChild(script);
    };
  }, []);
}
